import { DependenciesInjection } from "app/di/DependencyInjection";
import { ChangePasswordImpl } from "../data/ChangePasswordImpl";
import { IChangePasswordRepository } from "../domain/repositories/IChangePasswordRepository";
import { ChangePasswordUseCase } from "../domain/useCases/ChangePasswordUseCase";
import { ChangePasswordToken } from "./ChangePasswordToken";

export class ChangePasswordInjection {
  static initInjections() {
    DependenciesInjection.register<IChangePasswordRepository>(
      ChangePasswordToken.IChangePasswordRepository,
      ChangePasswordImpl,
      "otherRepo",
    );
    DependenciesInjection.register<ChangePasswordUseCase>(
      ChangePasswordToken.ChangePasswordUseCase,
      ChangePasswordUseCase,
      "otherRepo",
    );
  }

  static getRepo() {
    return DependenciesInjection.getRepo<IChangePasswordRepository>(
      ChangePasswordToken.IChangePasswordRepository,
    );
  }

  static getUseCase() {
    return DependenciesInjection.getRepo<ChangePasswordUseCase>(
      ChangePasswordToken.ChangePasswordUseCase,
    );
  }
}
